import React from "react";
import Select from "./Select.jsx";

const SelectAnio = ({ value, setValue }) => {
  const anioActual = new Date().getFullYear();
  const defaultOption = { value: anioActual, label: anioActual };

  const options = Array.from({ length: 5 }, (_, i) => {
    return {
      key: i,
      value: anioActual - i - 1,
      label: anioActual - i - 1,
    };
  });

  return (
    <Select
      id="selectAnio"
      name="selectAnio"
      value={value}
      setValue={setValue}
      defaultOption={defaultOption}
      options={options}
    />
  );
};

export default SelectAnio;
